import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Phone, Mail, MapPin, Linkedin, Facebook, Twitter, Instagram } from 'lucide-react';
import { useAppContext } from '../../context/AppContext';

const Footer = () => {
  const { setContactFormOpen } = useAppContext();
  const navigate = useNavigate();
  const location = useLocation();

  // Helper: navigate to a path, then scroll to top AFTER the route changes
  const go = (path) => (e) => {
    e.preventDefault();
    if (location.pathname !== path) {
      navigate(path);
      requestAnimationFrame(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    } else {
      // Already on the page—just scroll up
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-neutral-950 text-gray-300 py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8 mb-10">
          <div>
            <h3 className="text-2xl font-extrabold tracking-wide mb-4">
              <span className="text-white">EXCESS</span>
              <span className="text-[#d40000]">D</span>
            </h3>
            <p className="mb-5 text-gray-400">
              Your premium technology and software engineering partner to establish a strategic presence in India.
            </p>
            <div className="flex space-x-4">
              <a href="#" aria-label="LinkedIn" className="text-gray-400 hover:text-[#d40000] transition">
                <Linkedin size={20} />
              </a>
              {/* <a href="#" aria-label="Facebook" className="text-gray-400 hover:text-[#d40000] transition">
                <Facebook size={20} />
              </a>
              <a href="#" aria-label="Twitter" className="text-gray-400 hover:text-[#d40000] transition">
                <Twitter size={20} />
              </a> */}
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4 text-white">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                {/* Company → About Us */}
                <a
                  href="/company/about-us"
                  onClick={go('/company/about-us')}
                  className="cursor-pointer hover:text-white transition-colors"
                >
                  <span className="border-b border-transparent hover:border-[#d40000]">Company</span>
                </a>
              </li>
              <li>
                {/* Engineering */}
                <a
                  href="/engineering"
                  onClick={go('/engineering')}
                  className="cursor-pointer hover:text-white transition-colors"
                >
                  <span className="border-b border-transparent hover:border-[#d40000]">Engineering</span>
                </a>
              </li>
              <li>
                {/* Careers → Working in EXCESSD */}
                <a
                  href="/careers/working-in-excessd"
                  onClick={go('/careers/working-in-excessd')}
                  className="cursor-pointer hover:text-white transition-colors"
                >
                  <span className="border-b border-transparent hover:border-[#d40000]">Careers</span>
                </a>
              </li>
              <li>
                {/* Contact Us (keeps your modal behavior) */}
                <button
                  onClick={() => {
                    setContactFormOpen(true);
                    // Also scroll up so the modal (if pinned near top) feels natural
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                  className="text-left hover:text-white transition-colors"
                >
                  <span className="border-b border-transparent hover:border-[#d40000]">Contact Us</span>
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4 text-white">Services</h3>
            <ul className="space-y-2">
              <li><span className="hover:text-white transition-colors border-b border-transparent hover:border-[#d40000]">Dedicated Teams</span></li>
              <li><span className="hover:text-white transition-colors border-b border-transparent hover:border-[#d40000]">Build-Operate-Manage</span></li>
              <li><span className="hover:text-white transition-colors border-b border-transparent hover:border-[#d40000]">Engineering Services</span></li>
              <li><span className="hover:text-white transition-colors border-b border-transparent hover:border-[#d40000]">Domain Expertise</span></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4 text-white">Contact Us</h3>
            <ul className="space-y-3 text-gray-400">
              <li className="flex items-start">
                <MapPin size={18} className="mr-2 mt-1 flex-shrink-0 text-[#d40000]" />
                <span>Lucknow, Uttar Pradesh, India</span>
              </li>
              {/* <li className="flex items-center">
                <Phone size={18} className="mr-2 flex-shrink-0 text-[#d40000]" />
                <span>+91 (80) 4567 8901</span>
              </li> */}
              <li className="flex items-center">
                <Mail size={18} className="mr-2 flex-shrink-0 text-[#d40000]" />
                <span>info@excessd.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* <div className="border-t border-neutral-800 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500">&copy; {new Date().getFullYear()} EXCESSD. All rights reserved.</p>
            <ul className="flex space-x-6">
              <li><a href="#" className="text-gray-400 hover:text-[#d40000] text-sm transition">Privacy Policy</a></li>
              <li><a href="#" className="text-gray-400 hover:text-[#d40000] text-sm transition">Terms of Service</a></li>
              <li><a href="#" className="text-gray-400 hover:text-[#d40000] text-sm transition">Cookie Policy</a></li>
            </ul>
          </div>
        </div> */}
      </div>
    </footer>
  );
};

export default Footer;
